import React from "react";

interface Props {
  height?: number;
}

export default function Separator(props: Props) {
  return (
    <div
      style={{
        height: props.height || 30
      }}
    >
      &nbsp;
    </div>
  );
}
